// Mobile sizing for HomeHero. The Figma mobile frame is a 319px-wide phone with the hero edge to
// edge, and every mobile measurement is a proportion of that width — so on a wider phone the
// badge, pill, photo, type and dots grow with the panel instead of staying fixed and drifting
// into the corners. One Figma pixel is `--u`: 1/319 of the hero's width (container query units,
// set on the hero's root below md), never smaller than 1px and capped so a tablet-width stack
// doesn't turn into poster type.

/** Width of the Figma mobile frame (node 3004:4313's phone). */
export const MOBILE_FRAME_PX = 319;
/** Largest mobile scale (≈ a 560px-wide hero). */
export const MOBILE_MAX_SCALE = 1.75;

/** The `--u` definition, for the hero root's mobile styles (needs `container-type`). */
export const MOBILE_UNIT_VAR = `clamp(1px, calc(100cqw / ${MOBILE_FRAME_PX}), ${MOBILE_MAX_SCALE}px)`;

/** A Figma mobile measurement in hero units, for styles. */
export const u = (figmaPx: number) => `calc(var(--u) * ${figmaPx})`;

/** The same scale in JS, for the few sizes that must be numbers (the badge canvas). */
export const mobileScale = (heroWidth: number | null) =>
  heroWidth ? Math.min(MOBILE_MAX_SCALE, Math.max(1, heroWidth / MOBILE_FRAME_PX)) : 1;
